import { ShowOrgMemberRequestSchema, ShowOrgMemberResponseSchema } from './show-org-member.schema';
/**
 * Show Org Member Endpoint Contract
 * Retrieves a specific organization member by ID
 */ export const showOrgMemberContract = {
    method: 'GET',
    path: '/api/v2/org-member/:id',
    description: 'Retrieve a specific organization member by ID',
    requestSchema: ShowOrgMemberRequestSchema,
    responseSchema: ShowOrgMemberResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Organization member not found'
        }
    }
};

//# sourceMappingURL=show-org-member.contract.js.map